import MONSTRO_8 from "url:../sprites/juizinho.png";
import SOM_5 from "url:../sfx/ooohhhh.m4a";

export default {
  attack: 1,
  life: 10,
  speed: 5,
  agility: 7,
  weapon: 1,
  image: MONSTRO_8,
  sound: SOM_5,
};
